import React, { useState } from "react";
import { Check, Link2 } from "lucide-react";
import { useDialog } from "contexts/DialogContext";
import { useI18n } from "i18n";

/**
 * Copia um link para a area de transferencia — o da busca por selfie
 * (`?search=<uuid>`), que reabre exatamente as fotos encontradas.
 *
 * Diferente do `ShareButton`, nao abre a Web Share API: o pedido aqui e
 * "copiar", para colar onde o visitante quiser.
 *
 * `url` e uma FUNCAO chamada no clique: o link leva o `?ts=` daquele momento
 * (ver `lib/share.js`).
 */
export default function CopyLinkButton({ url, label, className = "" }) {
  const { t } = useI18n();
  const { alert } = useDialog();
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    const link = url();
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Sem clipboard (contexto inseguro, permissao negada): mostramos a URL no
      // modal do proprio sistema — nunca um popup nativo do navegador.
      await alert({ title: label, description: link, variant: "info" });
    }
  };

  return (
    <button
      type="button"
      onClick={copy}
      className={`inline-flex items-center gap-2 rounded-full border border-amber-300 bg-white px-4 py-2 text-sm font-semibold text-amber-700 transition-colors hover:bg-amber-50 ${className}`}
    >
      {copied ? <Check size={16} /> : <Link2 size={16} />}
      {copied ? t("common.copied") : label}
    </button>
  );
}
